import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getFiltersOptionsAction } from '../actions';

const {
  useLoaderData: StudentRiskFiltersLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({ action: getFiltersOptionsAction });

function StudentRiskFiltersLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  StudentRiskFiltersLoader as StudentRiskPrimaryFiltersLoader,
  StudentRiskFiltersLoaderData as StudentRiskPrimaryFiltersLoaderData,
};
